function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8857 6.22222H10.2143V4.08889C10.2143 1.51378 8.97464 0 6.5 0C4.02443 0 2.78571 1.51378 2.78571 4.08889V4.44444H4.64286V3.73244C4.64286 2.448 5.38293 1.77778 6.5 1.77778C7.61707 1.77778 8.35714 2.448 8.35714 3.73244V6.22222H0.928571C0.415071 6.22222 0 6.79644 0 7.288V14.2222C0 14.7102 0.397429 15.2347 0.883071 15.384L1.99457 15.728C2.58412 15.8925 3.19329 15.9839 3.80714 16H9.19286C9.80649 15.9841 10.4154 15.8923 11.0045 15.7271L12.1151 15.3831C12.6016 15.2347 13 14.7102 13 14.2222V7.288C13 6.79644 12.3983 6.22222 11.8857 6.22222Z",
  fill: "currentColor"
});

function SvgLockOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.77f41cc3.svg";
export { ForwardRef as ReactComponent };